import moment from "moment";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Button, Grid, Modal } from "semantic-ui-react";

import { ROLES } from "../Users/roles";
import { FileDropDown } from "./../../components";

import IntegrationsService from "../../integrations/service";
import {
  CAR_NOTE_TYPES,
  getDealerAndLocationById,
  getFileUploadErrorMessage,
  getFilesButton,
  getMaxFileSizeError,
  isFileSizeExceeded,
  sortTruckTires,
} from "../../util/common";
import { TYRE_POSITION } from "../Appointments/common";
import AppointmentHistory from "./AppointmentHistory";
import CarDetailHeader from "./CarDetailHeader";
import CarDetailMenu from "./CarDetailMenu";
import CarDrivingTrend from "./CarDrivingTrend";
import CarNotes from "./CarNotes";
import CarPins from "./CarPins";
import CarSnoozed from "./CarSnoozed";
import CarTyres from "./CarTyres";
import { addCarAttachment, applyWebsocketUpdate, CARS_ACTION_TYPES, deleteCarAttachment, getCar, updateSelectedCar } from "./store";
import TruckTyres from "./TruckTyres";

import AppointmentService from "../Appointments/service";
import { getAppointment } from "../Appointments/store";
import Service from "./service";

import "./CarDetail.css";

class CarDetail extends React.Component {
  constructor(props) {
    super(props);

    if (props.car.is_truck) this.truck_tyres = this.prepareTruckTires(props.car.truck_tyres);

    this.state = {
      car_widget: "",
      button_label: "S",
      car: this.props.car,
      appointmentHistory: [],
      appointment: null,
      fileUploadError: "",
    };
  }

  prepareTruckTires = tires => {
    const truck_tyres = {};
    let spareTiresCount = 0;

    (tires || []).forEach(tyre => {
      const placeholderTyre = { ...tyre };

      let tiresGroup;
      if (placeholderTyre.position === TYRE_POSITION.TRUCK_SPARE) {
        placeholderTyre.spareTiresCount = ++spareTiresCount;
        tiresGroup = `spare_${spareTiresCount}`;
      } else tiresGroup = placeholderTyre.axle;

      if (!truck_tyres[tiresGroup]) truck_tyres[tiresGroup] = [];

      truck_tyres[tiresGroup].push(placeholderTyre);
    });

    sortTruckTires(truck_tyres);

    return truck_tyres;
  };

  componentDidMount() {
    const lastAppointment = this.props.appointmentHistory?.length && this.props.appointmentHistory[0];

    this.getCarWidget();

    AppointmentService.getAppointment(lastAppointment.id)
      .then(response => {
        this.setState({ appointment: response.data.data });
      })
      .catch(error => console.log("Error getting appointment", error));

    const appointmentHistory = this.props.appointmentHistory.map(app => {
      let location_name = "";

      this.props.globalState.dealers.forEach(d => {
        if (d.locations)
          d.locations.forEach(l => {
            if (l.id === app.dealer_location_id) location_name = l.name;
          });
      });

      return { ...app, location_name };
    });

    this.setState({ appointmentHistory });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.carsState.selectedCar !== this.props.carsState.selectedCar) {
      this.setState({ car: this.props.carsState.selectedCar });
    }

    if (prevProps.carsState.actionType !== this.props.carsState.actionType && this.props.carsState.actionType === CARS_ACTION_TYPES.WEB_SOCKET_UPDATE) {
      this.props.applyWebsocketUpdate(this.props.carsState.webSocketUpdate);
    }
  }

  getCarWidget = () => {
    let { car } = this.props;

    if (car) {
      IntegrationsService.getCarWidget({ car_id: car.id })
        .then(result => {
          if (result?.data?.data?.redirect_url) {
            const { redirect_url, button_label } = result.data.data;

            this.setState({
              car_widget: redirect_url,
              button_label: button_label ? button_label : "S",
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.setState({ car_widget: "", button_label: "S" });
        });
    }
  };

  handleOpenSWidget = () => {
    window.open(this.state.car_widget, "_blank");
  };

  handleAddFile = files => {
    const {
      t,
      globalState: { dealers },
    } = this.props;
    const { car } = this.state;

    const filesToUpload = files.filter(file => !isFileSizeExceeded(file));

    this.setState({ fileUploadError: filesToUpload.length === files.length ? "" : getMaxFileSizeError(t) });

    if (!filesToUpload.length) return;

    const dealer = dealers.find(d => d.id === car.dealer_id);

    const date = moment(car.created_on).format("YYYY/MM/DD");
    const path = `${dealer?.id}_${dealer?.name}/${date}/${car.id}_${car.reg_nr}`;

    const uploads = filesToUpload.map(file => {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("path", path);

      const attachment = {
        type: file.type,
        name: file.name,
      };

      return Service.uploadAttachment(fd)
        .then(result => {
          if (!result?.data?.data?.url) throw new Error("Missing attachment url");

          attachment.url = result.data.data.url;
          return attachment;
        })
        .catch(error => {
          console.error("Error uploading the car attachment updates.", error);

          this.setState({ fileUploadError: getFileUploadErrorMessage(error, t) });

          attachment.failed = true;
          return attachment;
        });
    });

    Promise.all(uploads).then(attachments => {
      const uploadedAttachments = attachments.filter(attachment => !attachment.failed);
      const failedAttachments = attachments.filter(attachment => attachment.failed);

      const currentCar = this.props.carsState.selectedCar?.id === car.id ? this.props.carsState.selectedCar : car;
      const carNote = currentCar.notes?.find(n => n.car_note_type_id === CAR_NOTE_TYPES.DEFAULT);

      const newCarNote = {
        car_note_type_id: CAR_NOTE_TYPES.DEFAULT,
        car_id: car.id,
        note: "Attachment",
      };

      if (!uploadedAttachments.length) {
        this.props.addCarAttachment({ ...(carNote || newCarNote), attachments: [...(carNote?.attachments || []), ...failedAttachments] });
        return;
      }

      if (carNote) {
        const notePayload = { ...carNote, attachments: [...(carNote.attachments || []), ...uploadedAttachments] };

        Service.updateNote(notePayload)
          .then(() => {
            uploadedAttachments.forEach(attachment => {
              attachment.username = this.props.authState.user.first_name + " " + this.props.authState.user.last_name;
              attachment.created_on = new Date();
            });
            this.props.addCarAttachment({ ...notePayload, attachments: [...notePayload.attachments, ...failedAttachments] });
          })
          .catch(error => {
            console.error("Error saving the car attachment updates.", error);

            uploadedAttachments.forEach(attachment => (attachment.failed = true));
            this.props.addCarAttachment({ ...notePayload, attachments: [...notePayload.attachments, ...failedAttachments] });
          });
      } else {
        const notePayload = {
          ...newCarNote,
          attachments: uploadedAttachments,
          visible_to_mechanic: true,
        };

        Service.createNote(notePayload)
          .then(response => {
            notePayload.id = response?.data?.data?.car_note_id;
            uploadedAttachments.forEach(attachment => {
              attachment.username = this.props.authState.user.first_name + " " + this.props.authState.user.last_name;
              attachment.created_on = new Date();
            });
            this.props.addCarAttachment({ ...notePayload, attachments: [...notePayload.attachments, ...failedAttachments] });
          })
          .catch(error => {
            console.error("Error saving the car attachment updates.", error);

            uploadedAttachments.forEach(attachment => (attachment.failed = true));
            this.props.addCarAttachment({ ...notePayload, attachments: [...notePayload.attachments, ...failedAttachments] });
          });
      }
    });
  };

  handleRemoveFile = url => {
    const { car } = this.state;

    const carNote = car.notes?.find(n => n.car_note_type_id === CAR_NOTE_TYPES.DEFAULT);
    const attachments = carNote?.attachments.filter(att => att.url !== url);

    Service.updateNote({ ...carNote, attachments })
      .then(() => this.props.deleteCarAttachment(url))
      .catch(error => {
        console.error("Error deleting attachment on car detail.", error);
      });
  };

  handleContractCreated = () => {
    const { car } = this.state;
    const { selectedAppointment } = this.props.appointmentsState;

    if (selectedAppointment?.car_id === car.id) this.props.getAppointment(selectedAppointment.id);
    this.props.getCar(car.id);
  };

  render() {
    const { car, appointmentHistory, appointment, fileUploadError } = this.state;

    const { customer, visible, onHide, globalState, authState, isURLHandler, location, updateSelectedCar, t } = this.props;

    if (!car) return null;

    const carAttachments = car.notes?.find(n => n.car_note_type_id === CAR_NOTE_TYPES.DEFAULT)?.attachments || [];

    return (
      <span>
        <Modal className="CarDetailModal" size="fullscreen" dimmer="inverted" onClose={onHide} closeOnDimmerClick={false} open={visible}>
          <Modal.Header>
            <Grid>
              <Grid.Column width={5} floated="right">
                {!isURLHandler && (
                  <Button
                    color="green"
                    size="large"
                    floated="right"
                    onClick={onHide}
                    style={{
                      fontSize: "1.05rem",
                    }}
                    className="-margin-left-10"
                  >
                    {t("close").message || "Close"}
                  </Button>
                )}

                {globalState.selectedLocation.service_box_visible_on_car ? (
                  <Button basic size="large" floated="right" className="-margin-left-10" style={{ fontSize: "1.05rem" }} onClick={this.handleOpenSWidget}>
                    {this.state.button_label}
                  </Button>
                ) : (
                  ""
                )}

                <div className="FileDropDownCarDetail">
                  <FileDropDown
                    resource="cars"
                    position="left"
                    addFileText={t("drag_here_or_browse").message || "Drag here or browse"}
                    noFilesText={t("no_files").message || "No files"}
                    files={carAttachments}
                    trigger={getFilesButton({
                      count: carAttachments?.length > 0 ? carAttachments.filter(attachment => !attachment.failed).length : null,
                    })}
                    onFileAdded={this.handleAddFile}
                    deleteFile={this.handleRemoveFile}
                    uploadError={fileUploadError}
                    onClose={() => this.setState({ fileUploadError: "" })}
                    showPreview
                    showCount={false}
                    showIcon={true}
                    multiple
                    disableUpload={!getDealerAndLocationById(globalState.dealers, car.dealer_location_id).location?.is_car_note_enabled}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={16}>
                <CarDetailMenu />
              </Grid.Column>
            </Grid>
          </Modal.Header>
          <Modal.Content scrolling id="carDetailModalScrollContainer">
            <Grid className="CarDetailModal__Content">
              <Grid.Column width={16} id="cardetailscrollsection-cardetails">
                <CarDetailHeader car={car} customer={customer} selectedLocation={location} appointment={appointment} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-dmsnotes">
                <CarNotes car={car} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-snoozeditems">
                <CarSnoozed car={car} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-pinitems">
                <CarPins car={car} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-appointment_history">
                <AppointmentHistory appointmentHistory={appointmentHistory} isManufacturer={authState.user.role_id === ROLES.MANUFACTURER} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-drivingtrend">
                <CarDrivingTrend appointmentHistory={appointmentHistory} car_lead_prediction={car.car_lead_prediction} />
              </Grid.Column>
              <Grid.Column width={16} id="cardetailscrollsection-tyres">
                {car.is_truck ? (
                  <TruckTyres truck_tyres={this.truck_tyres} selectedLocation={location} />
                ) : (
                  <CarTyres
                    car={car}
                    selectedLocation={location}
                    carLocation={getDealerAndLocationById(globalState.dealers, car.dealer_location_id).location}
                    customers={this.props.carsState.selectedCustomer}
                    lastAppointment={appointmentHistory?.length && appointmentHistory[0]}
                    updateSelectedCar={updateSelectedCar}
                    onContractCreated={this.handleContractCreated}
                  />
                )}
              </Grid.Column>
            </Grid>
          </Modal.Content>
        </Modal>
      </span>
    );
  }
}

const mapStateToProps = state => {
  return { authState: state.auth, globalState: state.global, carsState: state.cars, appointmentsState: state.appointments };
};

const mapDispatchToProps = dispatch => {
  return {
    applyWebsocketUpdate: payload => dispatch(applyWebsocketUpdate(payload)),
    addCarAttachment: attachmentNote => dispatch(addCarAttachment(attachmentNote)),
    deleteCarAttachment: url => dispatch(deleteCarAttachment(url)),
    updateSelectedCar: update => dispatch(updateSelectedCar(update)),
    getCar: carID => dispatch(getCar(carID)),
    getAppointment: appID => dispatch(getAppointment(appID)),
  };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CarDetail));
